import React from 'react';
import store from "../../../../../../store";

import {openModalFix, updateFeatureIdModalFix} from "../../../../../../actions/sqftModalFunctions";
import {
  clearCacheForTheEdgeFeatures,
  setSQFTActiveButton,
  setSQFTMenuOpened
} from "../../../../../../actions/sqftMenuFunctions";
import {
  BACKSPLASH_LABELS,
  COUNTERTOP_LABELS,
  EDGE_LABELS,
  SIDEBAR_NAVIGATION_BUTTONS, SIDEBAR_NAVIGATION_CABINET_BUTTONS,
  SQFT_FEATURES,
} from "../../../../constants";
import {getCurrentLayout} from "../../../../../appLayout";
//import {getFeatureGroupName} from "../../../../../../misc/helpers";
//import workspace from "../../../canvas/core/workspace";
import {enableSquareFootage, setSQFTInVisualizer} from "../../../../../../actions/sqftFunctions";
import {getWizardGroupName} from "../../../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import workspace from "../../../canvas/core/workspace";
import workspaceZoom from "../../../canvas/core/workspaceZoom";
import {getShapesCenter} from "../../../../helpers/conflictPopupHelper";
import sqftConfig from "../../../canvas/store/sqftConfig";
import {changeCartFeature, removeManyFromCart} from "../../../../../../actions/actionFunctions";
import sqftShapeManager from "../../../canvas/store/sqftShapeManager";
import {prepareSQFTData, prepareSQFTDataCore} from "../../../canvas/core/workspace/workspaceDataMapper";
import {saveSQFTDataToQuote} from "../../../../helpers/sqftQuotesHelper";
import {fetchFeatures} from "../../../../hocs/useFetchFeatures";
import CommonCompatibilityUpdateWarning from "./CommonCompatibilityUpdateWarning";
import CommonCompatibilityRemoveWarning from "./CommonCompatibilityRemoveWarning";
import {removeFromSqftCalcData} from "../../../../helpers/sqFtCalcDataHelper";
import {setWizardConflictSteps} from "../../../../../../actions/wizardFunctions";
import {changeAllCartItems} from "../../../../../../actions/shoppingCartFunctions";
import * as types from "../../../../../../actions/actionTypes";
import {getFeatureGroupName} from "../../../../../../misc/helpers";

export const handleOpenModalFix = async (props) => {
  const {changeWizardStepRoute} = props;
  const state = store.getState();
  const { wizardConflictingSteps, wizardList } = state.wizardState;
  const { cartItems } = state.cartState;
  const { sqftCartItems } = state.sqftResourceState;
  const { selectionFeatureInfo } = state.selectionState;
  const cartItemsAndSQFTTempCartItems = [...sqftCartItems, ...cartItems];
  const sortedWizardConflictingSteps = wizardConflictingSteps?.sort((a, b) => { return a.stepIndex - b.stepIndex;})
  const {isModalFixOpen} = state.sqftModalFixState;
  const {isSquareFootageEnabled} = state.sqftState;
  const fabricatorData = state.fabricatorState;
  const intl = workspace.intl;

  let cartItemsToChange = cartItemsAndSQFTTempCartItems.filter(cartItem => {
    return wizardConflictingSteps?.some(confObject => confObject.cartItemId === cartItem.id)
  });

  // cartItemsToChange = cartItemsToChange.sort((a, b) => {
  //   const stepA = wizardConflictingSteps.find(conf => conf.cartItemId === a.id)?.stepIndex ?? 0;
  //   const stepB = wizardConflictingSteps.find(conf => conf.cartItemId === b.id)?.stepIndex ?? 0;
  //   return stepA - stepB;
  // });
  //
  // const sqftCartItemsToChange = cartItemsToChange.filter(
  //   cartItem => cartItem.sqftId || Array.isArray(cartItem.sqftIds)
  // );

  // const partIdsToChange = [
  //   ...new Set(cartItemsToChange.map(cartItem => cartItem.partId))
  // ];
  //
  // console.log("partIdsToChange", partIdsToChange);

  const layout = getCurrentLayout();
  const steps = [];

  if (cartItemsToChange && cartItemsToChange.length && !isModalFixOpen && isSquareFootageEnabled) {
    for (const [index, wizardConflictingStep] of sortedWizardConflictingSteps.entries()) {
      const cartItem = cartItemsAndSQFTTempCartItems.find(cartItem => wizardConflictingStep.cartItemId === cartItem.id);

      if (cartItem) {
        const partId = cartItem.partId;
        const featureGroup = layout.getFeatureGroupByPartId(partId);
        //const fabricatorData = state.fabricatorState;
        //const intl = workspace.intl;
        //const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
        const isBacksplash = Object.keys(BACKSPLASH_LABELS).includes(partId);
        const isCountertop = Object.keys(COUNTERTOP_LABELS).includes(partId);
        const isSlab = partId === SQFT_FEATURES.slabs;
        //skip conflict for the slab
        if (isSlab) {
          continue;
        }

        const isSQFTStep = !!partId && !isBacksplash && !isCountertop && !isSlab;
        const isFirstStep = index === 0;
        const isLastStep = index === sortedWizardConflictingSteps.length - 1;
        const wizardItem = wizardList[0];
        const wizardGroup = wizardItem.wizardGroups.find(wizGroup => {
          return wizGroup.id === wizardConflictingStep.wizardGroupId
        });
        const wizardGroupName = getWizardGroupName(wizardGroup);
        const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
        const groupName = wizardGroupName || featureGroupName;
        const buttonName = getButtonNameForPartId(partId);
        const featuresData = await fetchFeatures([partId], '', true);
        const shouldRemove = !featuresData[partId]?.rows?.length ;
        const titleUpdate = intl.formatMessage({id: "modalFix.title.update"}, {groupName});
        const titleRemove = intl.formatMessage({id: "modalFix.title.delete"}, {groupName});
        const title = shouldRemove ? titleRemove : titleUpdate;

        //todo getContentForFeatureGroup Roja rPET
        steps.push(
          {
            id: 'incompatibleCartItems',
            title: title,
            content: getContentForFeatureGroup(featureGroup, groupName, shouldRemove),
            partId: cartItem.partId,
            featureId: cartItem.cartFeature.dbFeature.id,
            featureName: cartItem.cartFeature.getFeatureName(),
            isSQFTStep: isSQFTStep,
            params: {
              shouldRemove: shouldRemove,
              cartItemId: cartItem.id
            },
            showClose: false,
            showCancel: true,
            showSkip: false, //!isLastStep,
            showPrev: !isFirstStep,
            nextButtonText: isLastStep ? 'Finish' : 'Next',
            skipButtonText: 'Skip',
            enterAnim: 'fadeDown',
            exitAnim: 'fadeUp',
            onStepEnter: (stepData) => {
              if (isSQFTStep) {
                store.dispatch(setSQFTInVisualizer(false));
                if (stepData.isSQFTStep && !shouldRemove) {
                  if (featuresData[partId]?.rows?.length > 0) {
                    store.dispatch(setSQFTMenuOpened(buttonName));
                    store.dispatch(setSQFTActiveButton(buttonName));
                  }
                }

                setTimeout(() => {
                  const shapes = workspace.getShapesWithoutAttachedResources();
                  let centerPoint = getShapesCenter(shapes);
                  workspaceZoom.zoomTo(centerPoint, 0.1);
                }, 500);
              } else {
                store.dispatch(setSQFTInVisualizer(true));
                const wizardItem = wizardList[0];
                if (changeWizardStepRoute && !shouldRemove) {
                  changeWizardStepRoute(wizardConflictingStep.stepIndex, wizardItem);
                }

                sqftConfig.setScale(2.5);
                setTimeout(() => {
                  const shapes = workspace.getShapesWithoutAttachedResources();
                  let centerPoint = getShapesCenter(shapes);
                  workspaceZoom.zoomTo(centerPoint, 0.1);
                }, 500);
              }
            },
            onStepExit: (stepData) => {
              store.dispatch(setSQFTMenuOpened(''));
              store.dispatch(setSQFTActiveButton(''));
              void stepData
              //stepData.isSQFTStep ||

              if (selectionFeatureInfo) {
                store.dispatch(toggleSelectionFeatureInfo(null));
              }
            }
          }
        )
      }
    }

    console.log('steps', steps);

    // const buttonName = getButtonNameForPartId(partIdsToChange[0]);
    //
    // store.dispatch(setSQFTMenuOpened(buttonName));
    // store.dispatch(setSQFTActiveButton(buttonName));
    if (!isModalFixOpen) {
      store.dispatch(openModalFix('incompatibleCartItems', steps, () => {
        console.log('Modal completed - user updated edge style');
        deleteModalFixFeatures(steps);

        store.dispatch(setSQFTInVisualizer(false));
        store.dispatch(setWizardConflictSteps([]));
        //todo
        void enableSquareFootage;
        sqftConfig.initializeDependentProperties();
        //store.dispatch(closeModalFix());
        //store.dispatch(enableSquareFootage(false));
      }));
    }
  }
};

const getContentForFeatureGroup = (featureGroup, featureGroupName, shouldRemove) => {
  if (shouldRemove) {
    return React.createElement(CommonCompatibilityRemoveWarning, {
      featureGroup: featureGroup,
      featureGroupName: featureGroupName
    });
  } else {
    return React.createElement(CommonCompatibilityUpdateWarning, {
      featureGroup: featureGroup,
      featureGroupName: featureGroupName
    });
  }
}

const getButtonNameForPartId = (partId) => {
  if (Object.keys(EDGE_LABELS).includes(partId)) {
    return SIDEBAR_NAVIGATION_BUTTONS.edge
  } else if (Object.keys(BACKSPLASH_LABELS).includes(partId)) {
    return SIDEBAR_NAVIGATION_BUTTONS.backsplash
  } else if (SQFT_FEATURES.crown_molding === partId) {
    return SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding
  }
}

export const deleteModalFixFeatures = (steps) => {
  const cartItemIdsToRemove = [];
  const state = store.getState();
  const {quotes, activeQuoteIndex} = state.quotesState;
  const currentQuote = quotes[activeQuoteIndex];
  const cartItems = state.cartState.cartItems;
  const sqftCartItems = state.sqftResourceState.sqftCartItems;
  const allCartItems = [...cartItems, ...sqftCartItems];
  const sqftIdsToRemove = [];
  for (const step of steps) {
    if (step.params.shouldRemove) {
      cartItemIdsToRemove.push(step.params.cartItemId);
      const cartItem = allCartItems.find(cartItem => cartItem.id === step.params.cartItemId);

      //remove sqft items
      if (cartItem.sqftId) {
        workspace.removeFeatureBySQFTId(cartItem.sqftId);
        sqftIdsToRemove.push(cartItem.sqftId);
      }

      if (cartItem.sqftIds && cartItem.sqftIds.length) {
        for (const sqftId of cartItem.sqftIds) {
          workspace.removeFeatureBySQFTId(sqftId);
          sqftIdsToRemove.push(sqftId);
        }
      }
    }
  }
  removeFromSqftCalcData(currentQuote, sqftIdsToRemove);
  store.dispatch(removeManyFromCart(cartItemIdsToRemove));
}

export const fixFeature = async (currentFeature) => {
  const state = store.getState();
  const sqftModalFixState = state.sqftModalFixState;
  const isModalFixOpen = state.sqftModalFixState.isModalFixOpen;
  const cartItems = state.cartState.cartItems;

  if (isModalFixOpen) {
    const incompatibleFeatureId = sqftModalFixState.featureId;
    const updatedCartItems = [];
    //update cart item
    for (const cartItem of cartItems) {
      if (cartItem.cartFeature.dbFeature.id === incompatibleFeatureId) {
        const newItem = {
          ...cartItem,
          cartFeature: currentFeature
        };
        store.dispatch(changeCartFeature(newItem));
        updatedCartItems.push(newItem);
      }
    }

    //update sqft features
    // for (const updatedCartItem of updatedCartItems) {
    //   for (const sqftId of updatedCartItem.sqftIds) {
    //     sqftShapeManager.setShapeFeature(sqftId, updatedCartItem.cartFeature);
    //   }
    // }


    const incompatibleShapes = workspace.getShapesByFeatureId(incompatibleFeatureId);
    for (const incompatibleShape of incompatibleShapes) {
      sqftShapeManager.setShapeFeature(incompatibleShape.id, currentFeature);
    }
    const incompatibleParentShapes = workspace.getShapesByParentFeatureId(incompatibleFeatureId);
    for (const incompatibleShape of incompatibleParentShapes) {
      sqftShapeManager.setShapeRelatedParentFeatureId(incompatibleShape.id, currentFeature.dbFeature.id, currentFeature.partId);
    }

    let sqftCalcData = await prepareSQFTData();
    await saveSQFTDataToQuote(sqftCalcData);

    //update modal fix popup
    store.dispatch(updateFeatureIdModalFix(
      currentFeature.dbFeature.id,
      currentFeature.getFeatureName()
    ));
    store.dispatch(clearCacheForTheEdgeFeatures());
  }
}

/**
 * Create a snapshot of current state before making changes
 */
export const createModalFixSnapshot = () => {
  const state = store.getState();
  const cartItems = state.cartState.cartItems;
  //const sqftCartItems = state.sqftResourceState.sqftCartItems;

  // Get SQFT data without images (fast)
  const sqftCalcData = prepareSQFTDataCore();

  return {
    cartItems: cartItems,
    // sqftCartItems: JSON.parse(JSON.stringify(sqftCartItems)),
    sqftCalcData: sqftCalcData,
    timestamp: Date.now()
  };
};

/**
 * Restore state from snapshot
 */
export const restoreFromSnapshot = async (snapshot) => {
  if (!snapshot) {
    console.warn('No snapshot to restore');
    return;
  }

  console.log('Restoring from snapshot', snapshot);

  // 1. Restore cart items
  const cartItems = [...snapshot.cartItems];
  store.dispatch(changeAllCartItems(cartItems));

  // 2. Restore workspace state
  if (snapshot.sqftCalcData) {
    workspace.import(snapshot.sqftCalcData);
  }

  // 3. Update quotes with restored data
  let sqftCalcData = await prepareSQFTData();
  await saveSQFTDataToQuote(sqftCalcData);

  // 4. Restore wizard selected values
  const state = store.getState();
  store.dispatch({
    type: types.SET_WIZARD_SELECTED_VALUES,
    payload: {
      wizardSelectedValues: state.wizardState.beforeConflictSelectedValues ?? state.wizardState.wizardSelectedValues,
      wizardConflictingSteps: [],
    }
  })

  console.log('Snapshot restored successfully');
};
